module.exports = __webpack_public_path__ + "static/media/brisbane.417e5b41.svg";